import { Bot, Mic } from "lucide-react";
import { openChatbot } from "@/lib/chatbot";

const DEFAULT_SUB =
  "궁금한 점을 말씀해 주세요. AI가 실시간으로 안내해 드립니다.";

export default function HeroAiConsultBar({
  wrapClassName = "",
  className = "",
  pinned = false,
  subMessage = DEFAULT_SUB,
  onMicClick,
}) {
  const handleMicClick = () => {
    if (onMicClick) {
      onMicClick();
      return;
    }
    openChatbot({ voice: true });
  };

  return (
    <div
      className={`ds-hero-ai-bar-wrap ds-hero-clickable${pinned ? " ds-hero-ai-bar-wrap--pinned" : ""} ${wrapClassName}`.trim()}
      data-testid="hero-ai-consult-bar"
    >
      <div className={`ds-hero-ai-bar ds-hero-glass ${className}`.trim()}>
        <div className="ds-hero-ai-avatar">
          <div className="ds-hero-ai-avatar-inner">
            <Bot size={18} />
          </div>
          <span className="ds-hero-ai-status" aria-hidden="true" />
        </div>
        <div className="ds-hero-ai-text">
          <div className="ds-hero-ai-title">DSite AI ASSISTANT</div>
          <div className="ds-hero-ai-sub">{subMessage}</div>
        </div>
        <div className="ds-hero-audio-bars" aria-hidden="true">
          {Array.from({ length: 5 }).map((_, i) => (
            <span key={i} className="ds-hero-audio-bar" />
          ))}
        </div>
        <button
          type="button"
          className="ds-hero-mic-btn"
          aria-label="음성으로 AI 질문하기"
          onClick={handleMicClick}
        >
          <Mic size={16} />
        </button>
      </div>
    </div>
  );
}
